(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'babel-runtime/core-js/object/keys', 'react-emotion', './colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('babel-runtime/core-js/object/keys'), require('react-emotion'), require('./colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.keys, global.reactEmotion, global.colors);
    global.colorClasses = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _keys, _reactEmotion, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _keys2 = _interopRequireDefault(_keys);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    color: ', ';\n  '], ['\n    color: ', ';\n  ']);

  var colorClasses = {};

  (0, _keys2.default)(_colors2.default).forEach(function (color) {
    colorClasses[color] = (0, _reactEmotion.css)(_templateObject, _colors2.default[color]);
  });

  exports.default = colorClasses;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/colorClasses.js
// module id = 1556
// module chunks = 1